export default "__VITE_ASSET__b0368217__"